'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import { safeParseNumber } from '@morpho-org/blue-sdk-viem';
import { ZERO } from '@morpho-org/dapp-core';
import { formatters } from '@morpho-org/ui-v6/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui';
import { TotalMyDepositError, TotalMyDepositLoading } from '@/components/EarnPage/EarnDashboard/DashboardCard/ChartMyDeposits/TotalMyDeposit/states';
import { getParsedValue } from '@/helpers/formatters';
import { splitValueAndUnit } from '@/helpers/number';
import { useIsMobile } from '@/hooks/useBreakpoints';
import { useViewedAccountAddress } from '@/hooks/useViewedAccountAddress';
import { useDashboardEarnPositions } from '../hooks/useDashboardEarnPositions';
interface DashboardHeroTotalDepositProps {
  chainIds: ChainId[];
}
const DashboardHeroTotalDeposit = t0 => {
  const $ = _c(31);
  const {
    chainIds
  } = t0;
  const {
    address
  } = useViewedAccountAddress();
  const isMobile = useIsMobile();
  const {
    earnPositions,
    loading,
    isError
  } = useDashboardEarnPositions(address);
  let t1;
  if ($[0] !== chainIds) {
    t1 = new Set(chainIds);
    $[0] = chainIds;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const selectedChains = t1;
  let formattedValueAndUnit;
  let t2;
  if ($[2] !== earnPositions || $[3] !== selectedChains) {
    let t3;
    if ($[6] !== selectedChains) {
      t3 = position => selectedChains.has(position.vault.chainId);
      $[6] = selectedChains;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    const value = earnPositions.filter(t3).reduce(_temp, 0);
    const deposits = getParsedValue(value, safeParseNumber) ?? ZERO;
    const formatted = formatters.short.default("0.00").digits(2).of(deposits ?? ZERO, 18);
    formattedValueAndUnit = splitValueAndUnit(formatted);
    t2 = formatters.commas.unit("$").digits(2).of(deposits, 18);
    $[2] = earnPositions;
    $[3] = selectedChains;
    $[4] = formattedValueAndUnit;
    $[5] = t2;
  } else {
    formattedValueAndUnit = $[4];
    t2 = $[5];
  }
  const detailedFormattedValueAndUnit = t2;
  if (loading) {
    let t3;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <TotalMyDepositLoading />;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    return t3;
  }
  if (isError) {
    let t3;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <TotalMyDepositError />;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    return t3;
  }
  if (isMobile) {
    let t3;
    if ($[10] !== formattedValueAndUnit.value) {
      t3 = <span className="text-title-sm text-foreground">${formattedValueAndUnit.value}</span>;
      $[10] = formattedValueAndUnit.value;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    let t4;
    if ($[12] !== formattedValueAndUnit.unit) {
      t4 = <span className="text-title-sm text-secondary-foreground">{formattedValueAndUnit.unit}</span>;
      $[12] = formattedValueAndUnit.unit;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    let t5;
    if ($[14] !== t3 || $[15] !== t4) {
      t5 = <TooltipTrigger asChild={true}><div className="flex w-[fit-content] items-center justify-start">{t3}{t4}</div></TooltipTrigger>;
      $[14] = t3;
      $[15] = t4;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    let t6;
    if ($[17] !== detailedFormattedValueAndUnit) {
      t6 = !!detailedFormattedValueAndUnit && <TooltipContent>{detailedFormattedValueAndUnit}</TooltipContent>;
      $[17] = detailedFormattedValueAndUnit;
      $[18] = t6;
    } else {
      t6 = $[18];
    }
    let t7;
    if ($[19] !== t5 || $[20] !== t6) {
      t7 = <Tooltip>{t5}{t6}</Tooltip>;
      $[19] = t5;
      $[20] = t6;
      $[21] = t7;
    } else {
      t7 = $[21];
    }
    return t7;
  }
  let t3;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="text-title-md text-muted-foreground">$</span>;
    $[22] = t3;
  } else {
    t3 = $[22];
  }
  let t4;
  if ($[23] !== formattedValueAndUnit.unit || $[24] !== formattedValueAndUnit.value) {
    t4 = <TooltipTrigger asChild={true}><div className="flex cursor-default items-center gap-[2px]">{t3}<span className="text-title-md text-foreground">{formattedValueAndUnit.value}{formattedValueAndUnit.unit}</span></div></TooltipTrigger>;
    $[23] = formattedValueAndUnit.unit;
    $[24] = formattedValueAndUnit.value;
    $[25] = t4;
  } else {
    t4 = $[25];
  }
  let t5;
  if ($[26] !== detailedFormattedValueAndUnit) {
    t5 = !!detailedFormattedValueAndUnit && <TooltipContent>{detailedFormattedValueAndUnit}</TooltipContent>;
    $[26] = detailedFormattedValueAndUnit;
    $[27] = t5;
  } else {
    t5 = $[27];
  }
  let t6;
  if ($[28] !== t4 || $[29] !== t5) {
    t6 = <Tooltip>{t4}{t5}</Tooltip>;
    $[28] = t4;
    $[29] = t5;
    $[30] = t6;
  } else {
    t6 = $[30];
  }
  return t6;
};
export default DashboardHeroTotalDeposit;
function _temp(acc, position_0) {
  return acc + (position_0.assetsUsd ?? 0);
}